import React, { useMemo, useRef, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { NavItem } from './NavItem';
import { Loader } from 'common/react/components/Loader';
import { useGetCurrentRoundNumber } from '../hooks/use-find-current-round';
import { navSelector } from 'common/store/modules/competition-nav/selectors';
import { changeRound } from 'common/store/modules/competition-nav/thunks';

export const RoundListNavItem = () => {
    const dispatch = useDispatch();
    const nav = useSelector(navSelector);
    const roundsListRef = useRef();
    const roundsList = nav?.rounds;

    const [isLoading, setIsLoading] = useState(true);

    // Filter to only home and away rounds (not finals)
    const filteredRoundList = useMemo(() => {
        if (roundsList) {
            setIsLoading(false);
            return roundsList.filter((round) => {
                return (
                    round.name.toLowerCase().includes('round') ||
                    (round.name.toLowerCase().includes('week') &&
                        !round.name.toLowerCase().includes('finals week'))
                );
            });
        }

        setIsLoading(true);
        return [];
    }, [roundsList]);

    const onNavItemClick = (value) => {
        roundsListRef?.current.dispatchEvent(
            new Event(PULSE.app.common.CONSTANTS.EVENTS.INTERACTION.CHANGE, {
                bubbles: true
            })
        );

        dispatch(
            changeRound({
                round: value
            })
        );
    };

    const currentRoundNumber = useGetCurrentRoundNumber(nav.season.providerId);

    return (
        <ul
            className="player-awards-round-by-round__round-list-nav"
            ref={roundsListRef}
        >
            {isLoading ? (
                <div className="player-awards-round-by-round__round-loader">
                    <Loader />
                </div>
            ) : filteredRoundList.length ? (
                filteredRoundList.map((round, index) => (
                    <NavItem
                        key={index}
                        value={round.roundNumber}
                        isCurrent={currentRoundNumber === round.roundNumber}
                        onClick={() => {
                            onNavItemClick(round);
                        }}
                    />
                ))
            ) : null}
        </ul>
    );
};
